import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';

import { BarMeldingenEngine } from '../providers/bar-meldingen-engine.provider';

export function barMeldingGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        if (!route.routeConfig?.component) return true;
        const meldingEngine = inject(BarMeldingenEngine);
        return meldingEngine.retrieveAndProcess(state.url);
    };
}
